// extracted by mini-css-extract-plugin
export default {"info":"henwu+HhCcUC-UsMjN3GfA==","info__header":"JNgTE+WqdusLvEiGZMb4pg==","info__headerNumber":"ZnmjQGQFNUpo-jkv5K4EYw==","info__headerText":"bWu4U6rhnfDdROQD99HMSA=="};